import * as React from 'react'
import { Link } from 'react-router-dom'

import { Select, SelectOption } from '../../components'
import ChartLayout from '../../models/chart_layout'
import { useChartTypes } from './use-chart-types'

const isNativeMobileSelect = true // explicitly enable native select for mobile devices

export function ChartTypesSelect({ isPremium, model }: { isPremium: boolean; model: ChartLayout }) {
  const { chartTypes, getCurrentType } = useChartTypes({ isPremium, model })
  const currentType = getCurrentType()

  return (
    <Select
      data-testid="chart-type-select"
      aria-label="Chart type"
      value={currentType}
      items={chartTypes}
      className="w-[7.25rem]"
      contentClass="truncate"
      size="medium"
      theme="chip"
      leftContent={chartTypes.find((item) => item.value === currentType)?.iconName}
      rightContent="caretDown"
      hasPopoverButtonWidthLimit={false}
      isNativeMobileSelect={isNativeMobileSelect}
    >
      {chartTypes.map((item) => (
        <SelectOption
          as={item.href ? Link : undefined}
          to={item.href}
          reloadDocument={item.href ? !window.FinvizSettings.hasUserPremium : undefined}
          data-testid={`chart-type-select-option-${item.value}`}
          key={item.value}
          leftContent={item.iconName}
        >
          {item.label}
        </SelectOption>
      ))}
    </Select>
  )
}
